import { render } from "./jdcxstyfp.vue?vue&type=template&id=0a8b00f8&scoped=true"
import script from "./jdcxstyfp.vue?vue&type=script&lang=js"
export * from "./jdcxstyfp.vue?vue&type=script&lang=js"

import "./jdcxstyfp.vue?vue&type=style&index=0&id=0a8b00f8&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a8b00f8"]])

export default __exports__